export interface IStickerTokenAmountProps {
  amount: number;
}

export default function StickerTokenAmount({
  amount,
}: IStickerTokenAmountProps) {
  return <>{amount === 1 ? "1 token" : `${amount} tokens`}</>;
}
